import TrialSearch from "./Content/Trials/TrialSearch";
import PublishedTrials from "./Content/Trials/PublishedTrials";
import TrialPublishing from "./Content/Trials/TrialPublishing";
import TrialViewer from "./Content/Trials/TrialViewer";
import TrialWizard from "./Content/Trials/TrialWizard";
import TrialHeatmap from "./Content/Trials/TrialHeatmap";
import TrialHeatmapLegacy from "./Content/Trials/TrialHeatmap/legacyIndex.js";
import TrialAnalysis from "./Content/Trials/TrialAnalysis";
import TrialGroundData from "./Content/Trials/TrialGroundData";
import TrialCurveModels from "./Content/Trials/TrialCurveModels";
import TrialWeather from "./Content/Trials/TrialWeather/index";

import { guidRegex } from "../utilities/regex";
import TrialAssessmentLog from "./Content/Trials/TrialAssessmentLog";
import { ApplicationArea } from "./Lumber/ApplicationAreas";
import MFASummary from "./Content/Trials/MFASummary/index.tsx";

//-- enabled has no effect if the parent module (i.e. the module referencing these routs in routs.js), is disabled
//--  That is, the enabled property cannot override the parent module enabled property if it is disabled

export const trialRoutes = [
	{
		id: "trial-search",
		name: "search",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Search",
		pageTitle: "Trial Search",
		icon: "search",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [
			`/trials`,
			`/trials/search`,
			`/flights/:id${guidRegex}/trials`,
			`/flights/:id${guidRegex}/trials/search`,
			`/fields/:id${guidRegex}/trials`,
			`/fields/:id${guidRegex}/trials/search`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/search`,
		],
		exact: true,
		component: TrialSearch,
		module: "trials",
		applicationAreas: [ApplicationArea.TrialSearch],
		requiresContext: false,
		showModuleIdInBreadcrumb: false,
	},
	{
		id: "published-trials",
		name: "published-trials",
		enabled: false, //disabled upon Jeremiah's request
		login: false,
		logout: false,
		home: false,
		linkText: "Published Trials",
		pageTitle: "Published Trials",
		icon: "book",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [
			`/trials/published-trials`,
			`/trials/:id${guidRegex}/published-trials`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/published-trials`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/published-trials`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/published-trials`,
		],
		exact: true,
		component: PublishedTrials,
		module: "trials",
		applicationAreas: [],
		requiresContext: false,
		showModuleIdInBreadcrumb: false,
	},
	{
		id: "trial-publishing",
		name: "trial-publishing",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Trial Publishing",
		pageTitle: "Trial Publishing",
		icon: "book",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [
			`/trials/trial-publishing`,
			`/trials/:id${guidRegex}/trial-publishing`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/trial-publishing`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/trial-publishing`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/trial-publishing`,
		],
		exact: true,
		component: TrialPublishing,
		module: "trials",
		applicationAreas: [ApplicationArea.TrialPublishing],
		requiresContext: true,
		showModuleIdInBreadcrumb: false,
	},
	{
		id: "trial-viewer",
		name: "viewer",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Viewer",
		pageTitle: "Trial Viewer",
		icon: "binoculars",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}`,
			`/trials/:id${guidRegex}/viewer`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/viewer`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/viewer`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/viewer`,
			`/trials/:id${guidRegex}/viewer/:id${guidRegex}`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/viewer/:id${guidRegex}`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/viewer/:id${guidRegex}`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/viewer/:id${guidRegex}`,
		],
		exact: true,
		component: TrialViewer,
		module: "trials",
		applicationAreas: [
			ApplicationArea.TrialViewer,
			ApplicationArea.TrialVisualHeatmapShading,
			ApplicationArea.TrialVisualHeatmapValues,
			ApplicationArea.TrialExportFunctionality,
			ApplicationArea.TrialDamagePlots,
			ApplicationArea.TrialDamagePlotsCRUD,
			ApplicationArea.TrialExcludePlots,
			ApplicationArea.TrialExcludePlotsCRUD,
			ApplicationArea.TrialFlagPlots,
			ApplicationArea.TrialFlagPlotsCRUD,
		],
		requiresContext: true,
	},
	{
		id: "trial-edit",
		navMatchingNames: ["edit", "treatments", "outline", "mapping", "meta-tags"],
		name: "edit",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Edit",
		pageTitle: "Edit Trial",
		icon: "pencil",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/edit`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/edit`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/edit`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/edit`,
		],
		exact: true,
		component: () => TrialWizard({ activeStep: "edit" }),
		module: "trials",
		applicationAreas: [ApplicationArea.TrialEdit],
		requiresContext: true,
	},
	{
		id: "trial-applications",
		name: "applications",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Applications",
		pageTitle: "Trial Applications",
		icon: null,
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/applications`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/applications`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/applications`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/applications`,
		],
		exact: true,
		component: () => TrialWizard({ activeStep: "applications" }),
		module: "trials",
		applicationAreas: [ApplicationArea.TrialEdit],
		requiresContext: true,
	},
	{
		id: "trial-treatments",
		navMatchingNames: ["edit", "treatments", "outline", "mapping", "meta-tags"],
		name: "treatments",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Treatments",
		pageTitle: "Trial Treatments",
		icon: null,
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/treatments`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/treatments`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/treatments`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/treatments`,
		],
		exact: true,
		component: () => TrialWizard({ activeStep: "treatments" }),
		module: "trials",
		applicationAreas: [ApplicationArea.TrialEdit],
		requiresContext: true,
	},
	{
		id: "trial-meta-tags",
		navMatchingNames: ["edit", "treatments", "outline", "mapping", "meta-tags"],
		name: "meta-tags",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Meta-Tags",
		pageTitle: "Trial Meta-Tags",
		icon: null,
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/meta-tags`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/meta-tags`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/meta-tags`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/meta-tags`,
		],
		exact: true,
		component: () => TrialWizard({ activeStep: "meta-tags" }),
		module: "trials",
		applicationAreas: [ApplicationArea.TrialEdit],
		requiresContext: true,
	},
	{
		id: "trial-mapping",
		navMatchingNames: ["edit", "treatments", "outline", "mapping", "meta-tags"],
		name: "mapping",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Mapping",
		pageTitle: "Trial Mapping",
		icon: null,
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/mapping`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/mapping`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/mapping`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/mapping`,
		],
		exact: true,
		component: () => TrialWizard({ activeStep: "mapping" }),
		module: "trials",
		applicationAreas: [ApplicationArea.TrialEdit],
		requiresContext: true,
	},
	{
		id: "trial-soil-fertility",
		name: "soil-fertility",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Soil Fertility",
		pageTitle: "Trial Soil Fertility",
		icon: null,
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/soil-fertility`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/soil-fertility`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/soil-fertility`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/soil-fertility`,
		],
		exact: true,
		component: () => TrialWizard({ activeStep: "soil-fertility" }),
		module: "trials",
		applicationAreas: [ApplicationArea.TrialEdit],
		requiresContext: true,
	},
	{
		id: "trial-maintenance",
		name: "maintenance",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Maintenance Records",
		pageTitle: "Trial Maintenance Records",
		icon: null,
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/maintenance`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/maintenance`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/maintenance`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/maintenance`,
		],
		exact: true,
		component: () => TrialWizard({ activeStep: "maintenance" }),
		module: "trials",
		applicationAreas: [ApplicationArea.TrialEdit],
		requiresContext: true,
	},
	{
		id: "trial-heatmap",
		name: "heatmap",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Heatmap",
		pageTitle: "Trial Heatmap",
		icon: "map",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/heatmap`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/heatmap`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/heatmap`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/heatmap`,
			`/trials/:id${guidRegex}/heatmap/:id${guidRegex}`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/heatmap/:id${guidRegex}`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/heatmap/:id${guidRegex}`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/heatmap/:id${guidRegex}`,
		],
		exact: true,
		component: TrialHeatmap,
		module: "trials",
		applicationAreas: [ApplicationArea.TrialHeatMap],
		requiresContext: true,
	},
	{
		id: "trial-heatmap-legacy",
		name: "heatmap-legacy",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Heatmap",
		pageTitle: "Trial Heatmap (Legacy)",
		icon: "map",
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/heatmap-legacy`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/heatmap-legacy`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/heatmap-legacy`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/heatmap-legacy`,
			`/trials/:id${guidRegex}/heatmap-legacy/:id${guidRegex}`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/heatmap-legacy/:id${guidRegex}`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/heatmap-legacy/:id${guidRegex}`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/heatmap-legacy/:id${guidRegex}`,
		],
		exact: true,
		component: TrialHeatmapLegacy,
		module: "trials",
		applicationAreas: [ApplicationArea.TrialHeatMap],
		requiresContext: true,
	},
	{
		id: "trial-analysis",
		name: "analysis",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Analysis",
		pageTitle: "Trial Analysis",
		icon: "chart bar outline",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/analysis`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/analysis`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/analysis`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/analysis`,
		],
		exact: true,
		component: TrialAnalysis,
		module: "trials",
		applicationAreas: [
			ApplicationArea.TrialAnalysis,
			ApplicationArea.TrialAnalysisTimecourse,
			ApplicationArea.TrialAnalysisBoxWhisker,
			ApplicationArea.TrialAnalysisSummaryTable,
			ApplicationArea.TrialAnalysisCorrelationMatrix,
		],
		requiresContext: true,
	},
	{
		id: "trial-analysis-scatter-plot",
		name: "analysis-scatter-plot",
		enabled: false,
		login: false,
		logout: false,
		home: false,
		linkText: "Scatter Plot",
		pageTitle: "Trial Analysis",
		icon: "chart bar outline",
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/analysis-scatter-plot`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/analysis-scatter-plot`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/analysis-scatter-plot`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/analysis-scatter-plot`,
		],
		exact: true,
		component: () => TrialAnalysis("scatter-plot"),
		module: "trials",
		applicationAreas: [],
		requiresContext: true,
	},
	{
		id: "trial-analysis-timecourse",
		name: "analysis-timecourse",
		enabled: false,
		login: false,
		logout: false,
		home: false,
		linkText: "Timecourse",
		pageTitle: "Trial Analysis",
		icon: "chart bar outline",
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/analysis-timecourse`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/analysis-timecourse`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/analysis-timecourse`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/analysis-timecourse`,
		],
		exact: true,
		component: () => TrialAnalysis("timecourse"),
		module: "trials",
		applicationAreas: [ApplicationArea.TrialAnalysisTimecourse],
		requiresContext: true,
	},
	{
		id: "trial-outline",
		navMatchingNames: ["edit", "treatments", "outline", "mapping", "meta-tags"],
		name: "outline",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Outline",
		pageTitle: "Trial Outline",
		icon: null,
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/outline`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/outline`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/outline`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/outline`,
		],
		exact: true,
		component: () => TrialWizard({ activeStep: "outline" }),
		module: "trials",
		applicationAreas: [ApplicationArea.TrialOutline, ApplicationArea.TrialEdit],
		requiresContext: true,
	},
	{
		id: "ground-data",
		name: "ground-data",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Ground Data",
		pageTitle: "Trial Ground Data",
		icon: "upload",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/ground-data`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/ground-data`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/ground-data`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/ground-data`,
			`/trials/:id${guidRegex}/ground-data/:id${guidRegex}`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/ground-data/:id${guidRegex}`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/ground-data/:id${guidRegex}`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/ground-data/:id${guidRegex}`,
		],
		exact: true,
		component: TrialGroundData,
		module: "trials",
		applicationAreas: [
			ApplicationArea.TrialGroundData,
			ApplicationArea.TrialGroundDataCRUD,
			ApplicationArea.TrialGroundDataTemplate,
		],
		requiresContext: true,
	},
	{
		id: "trial-assessment-log",
		name: "trial-assessment-log",
		enabled: false, //disabled upon Jeremiah's request
		login: false,
		logout: false,
		home: false,
		linkText: "Assessment Log",
		pageTitle: "Trial Assessment Log",
		icon: "list",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/trial-assessment-log`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/trial-assessment-log`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/trial-assessment-log`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/trial-assessment-log`,
		],
		exact: true,
		component: TrialAssessmentLog,
		module: "trials",
		applicationAreas: [],
		requiresContext: true,
	},
	{
		id: "trial-curve-model",
		name: "trial-curve-model",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Curve Model",
		pageTitle: "Trial Curve Model",
		icon: "chart area",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/trial-curve-model`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/trial-curve-model`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/trial-curve-model`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/trial-curve-model`,
		],
		exact: true,
		component: TrialCurveModels,
		module: "trials",
		applicationAreas: [ApplicationArea.TrialCurveModels, ApplicationArea.TrialCurveModelsCRUD],
		requiresContext: true,
	},
	{
		id: "trial-weather",
		name: "trial-weather",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Trial Weather",
		pageTitle: "Trial Weather",
		icon: "cloudy",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/trial-weather`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/trial-weather`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/trial-weather`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/trial-weather`,
		],
		exact: true,
		component: TrialWeather,
		module: "trials",
		applicationAreas: [ApplicationArea.TrialWeather, ApplicationArea.TrialWeatherCRUD],
		requiresContext: true,
	},
	{
		id: "trial-geo-mfa-explorer",
		name: "geo-mfa-explorer",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "geoMFA Explorer",
		pageTitle: "geoMFA Explorer",
		icon: "mfa",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/geo-mfa-explorer`,
			`/flights/:id${guidRegex}/trials/:id${guidRegex}/geo-mfa-explorer`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/geo-mfa-explorer`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/geo-mfa-explorer`,
		],
		exact: true,
		component: MFASummary,
		module: "trials",
		applicationAreas: [ApplicationArea.TrialGeoMFAExplorer],
		requiresContext: true,
	},
	{
		id: "trial-experimental-designs",
		name: "trial-experimental-designs",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Experimental Designs",
		pageTitle: "Experimental Designs",
		icon: null,
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [
			`/trials/:id${guidRegex}/experimental-designs`,
			`/fields/:id${guidRegex}/trials/:id${guidRegex}/experimental-designs`,
			`/flights/:id${guidRegex}/fields/:id${guidRegex}/trials/:id${guidRegex}/experimental-designs`,
		],
		exact: true,
		component: () => TrialWizard({ activeStep: "experimental-designs" }),
		module: "trials",
		applicationAreas: [ApplicationArea.TrialExperimentalDesignsCRUD, ApplicationArea.TrialExperimentalDesigns],
		requiresContext: true,
	},
];

export default {
	trialRoutes,
};
